export const name = 'gzTimePicker';
export default function gzTimePicker(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    require: '^ngModel',
    scope: {
      label: '@?',
    },
    template: require('./time-picker.jade'),
    link: timePickerLink,
    controller: timePickerController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function timePickerLink(scope, element, attrs, ngModelCtrl) {
    attrs.$observe('required', required => {
      element.find('label').toggleClass('required', required);
    });

    // Adapted from https://stackoverflow.com/a/34001183/277307
    scope.vm.setModelValue = (value) => {
      ngModelCtrl.$setViewValue(value);
    };

    ngModelCtrl.$render = () => {
      if (scope.vm.parseModel) {
        scope.vm.parseModel(ngModelCtrl.$modelValue);
      }
    };
  }

  /** @ngInject */
  function timePickerController(
    moment,
    $window
  ) {
    // Constants

    // Variables

    // View Model
    //   VM properties
    let vm = this;
    vm.is12Hour = false;
    vm.hourInput = '00';
    vm.minuteInput = '00';
    vm.meridiem = 'AM';
    //   VM methods
    vm.hourChanged = hourChanged;
    vm.minuteChanged = minuteChanged;
    vm.timeChanged = timeChanged;
    vm.formatHour = formatHour;
    vm.formatMinute = formatMinute;
    vm.selectInput = selectInput;
    vm.handleHourKey = handleHourKey;
    vm.handleMinuteKey = handleMinuteKey;
    vm.parseModel = parseModel;

    vm.$onInit = onInit;

    return;

    ///////////////
    // Init
    function onInit() {
      vm.is12Hour = moment.localeData().longDateFormat('LT')
        .toUpperCase()
        .includes('A');

      if (vm.is12Hour) {
        vm.hourInput = '12';
      }
    }

    ///////////////
    // VM methods
    function hourChanged() {
      let fixedInput = validateInput(vm.hourInput, 0, vm.is12Hour ? 12 : 23);
      if (fixedInput !== undefined) {
        vm.hourInput = fixedInput;
        return;
      }

      timeChanged();
    }

    function minuteChanged() {
      let fixedInput = validateInput(vm.minuteInput, 0, 59);
      if (fixedInput !== undefined) {
        vm.minuteInput = fixedInput;
        return;
      }

      timeChanged();
    }

    function timeChanged() {
      let hour = $window.Number.parseInt(vm.hourInput);
      let minute = $window.Number.parseInt(vm.minuteInput);

      if (vm.is12Hour) {
        if (hour === 12) {
          if (vm.meridiem === 'AM') {
            // 12:00 AM is 0:00 in 24-hour time
            hour = 0;
          }
        } else {
          if (vm.meridiem === 'PM') {
            // Anything not 12:00 PM is +12 hours
            hour += 12;
          }
        }
      }

      let formattedHour = hour.toString().padStart(2, '0');
      let formattedMinute = minute.toString().padStart(2, '0');
      vm.setModelValue(`${formattedHour}:${formattedMinute}`);
    }

    function formatHour() {
      if (!vm.hourInput) {
        vm.hourInput = vm.is12Hour ? '12' : '00';
      }
      if (!vm.is12Hour) {
        vm.hourInput = vm.hourInput.padStart(2, '0');
      }
    }

    function formatMinute() {
      if (!vm.minuteInput) {
        vm.minuteInput = '00';
      }
      vm.minuteInput = vm.minuteInput.padStart(2, '0');
    }

    function selectInput($event) {
      $event.target.select();
    }

    function handleHourKey($event) {
      if (!isSupportedKey($event)) {
        return;
      }
      if (!vm.hourInput) {
        return;
      }

      let hour = $window.Number.parseInt(vm.hourInput);
      if ($event.key === 'ArrowUp') {
        if (vm.is12Hour) {
          if (hour < 12) {
            hour++;
          } else {
            // wrap around
            hour = 1;
          }
        } else {
          if (hour < 23) {
            hour++;
          } else {
            hour = 0;
          }
        }
      } else if ($event.key === 'ArrowDown') {
        if (vm.is12Hour) {
          if (hour > 1) {
            hour--;
          } else {
            // wrap around
            hour = 12;
          }
        } else {
          if (hour > 0) {
            hour--;
          } else {
            hour = 23;
          }
        }
      }

      vm.hourInput = hour.toString();
      formatHour();
      timeChanged();
    }

    function handleMinuteKey($event) {
      if (!isSupportedKey($event)) {
        return;
      }
      if (!vm.minuteInput) {
        return;
      }

      let minute = $window.Number.parseInt(vm.minuteInput);

      if ($event.key === 'ArrowUp') {
        if (minute < 59) {
          minute++;
        } else {
          // wrap around
          minute = 0;
        }
      } else if ($event.key === 'ArrowDown') {
        if (minute > 0) {
          minute--;
        } else {
          // wrap around
          minute = 59;
        }
      }

      vm.minuteInput = minute.toString();
      formatMinute();
      timeChanged();
    }

    function isSupportedKey($event) {
      return $event.key === 'ArrowUp' || $event.key === 'ArrowDown';
    }

    // Allow for two-way binding with incoming changes to the time
    function parseModel(model) {
      if (!model) {
        return;
      }

      let parsed = moment(model, 'H:mm');
      if (!parsed.isValid()) {
        return;
      }

      vm.minuteInput = parsed.minute().toString();
      if (!vm.is12Hour) {
        vm.hourInput = parsed.minute().toString();
      } else {
        let hour = parsed.hour();

        vm.meridiem = hour >= 12 ? 'PM' : 'AM';
        if (hour > 12) {
          hour -= 12;
        } else if (hour === 0) {
          hour = 12;
        }
        vm.hourInput = hour.toString();
      }

      formatHour();
      formatMinute();
    }

    ///////////////
    // Helpers
    function validateInput(input, min, max) {
      if (!input) {
        return '';
      }

      if (input.length > 2) {
        return input.substring(0, 2);
      }

      let parsedInput = $window.Number.parseInt(input);
      if ($window.Number.isNaN(parsedInput)) {
        return '';
      }

      if (parsedInput < min) {
        return min.toString();
      }

      if (parsedInput > max) {
        return input.substring(0, 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/time-picker/time-picker.directive.js